export const formatTimeLabel = (value: Date) => {
  return value
    .toLocaleTimeString("en-AU", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .toLowerCase()
    .replace(":", ".")
    .replace(" ", "");
};

export const getOrdinalDay = (day: number) => {
  if (day >= 11 && day <= 13) {
    return `${day}th`;
  }

  const lastDigit = day % 10;

  if (lastDigit === 1) {
    return `${day}st`;
  }

  if (lastDigit === 2) {
    return `${day}nd`;
  }

  if (lastDigit === 3) {
    return `${day}rd`;
  }

  return `${day}th`;
};

export const formatLongDate = (value: Date) => {
  const month = value.toLocaleDateString("en-AU", { month: "long" });
  const day = getOrdinalDay(value.getDate());
  return `${day} of ${month} ${value.getFullYear()}`;
};

export const formatDateLabel = (value: Date) => {
  const now = new Date();

  const startOfToday = new Date(now);
  startOfToday.setHours(0, 0, 0, 0);

  const startOfValueDay = new Date(value);
  startOfValueDay.setHours(0, 0, 0, 0);

  const dayDiff = Math.round(
    (startOfValueDay.getTime() - startOfToday.getTime()) / (1000 * 60 * 60 * 24)
  );

  if (dayDiff === 0) {
    return `Today at ${formatTimeLabel(value)}`;
  }

  if (dayDiff === 1) {
    return `Tomorrow at ${formatTimeLabel(value)}`;
  }

  if (dayDiff > 1 && dayDiff < 7) {
    const weekday = value.toLocaleDateString("en-AU", { weekday: "long" });
    return `${weekday} at ${formatTimeLabel(value)}`;
  }

  const weekday = value.toLocaleDateString("en-AU", { weekday: "long" });
  const month = value.toLocaleDateString("en-AU", { month: "short" });
  const day = getOrdinalDay(value.getDate());
  return `${weekday} ${month} ${day}`;
};
